import React from 'react';
import '../../assets/styles/Pages.css';

const Terms = () => {
  return (
    <div className="page-content">
      <h1>Termos de Uso</h1>
      
      <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
      
      <section>
        <h2>1. Aceitação dos Termos</h2>
        <p>Ao acessar e usar este site, você indica que leu, entendeu e concorda em cumprir estes Termos de Uso.</p>
      </section>
      
      <section>
        <h2>2. Descrição do Serviço</h2>
        <p>A Calculadora de Juros Compostos oferece ferramentas para simular investimentos e calcular juros compostos. Todas as informações fornecidas são apenas para fins educacionais e informativos.</p>
      </section>
      
      <section>
        <h2>3. Uso da Calculadora</h2>
        <p>Os resultados das simulações são baseados nos dados fornecidos pelo usuário e em cálculos matemáticos padrão. Não garantimos a precisão absoluta dos resultados, que devem ser usados apenas como referência.</p>
        <p>Esta calculadora não substitui o aconselhamento financeiro profissional. Recomendamos consultar um profissional qualificado antes de tomar decisões de investimento.</p>
      </section>
      
      <section>
        <h2>4. Propriedade Intelectual</h2>
        <p>Todo o conteúdo deste site, incluindo textos, gráficos, logotipos, ícones, imagens e software, é propriedade da Calculadora de Juros Compostos e está protegido por leis de direitos autorais.</p>
      </section>
      
      <section>
        <h2>5. Limitação de Responsabilidade</h2>
        <p>Não nos responsabilizamos por quaisquer perdas ou danos, diretos ou indiretos, que possam resultar do uso deste site ou da confiança nas informações fornecidas.</p>
      </section>
      
      <section>
        <h2>6. Modificações</h2>
        <p>Reservamos o direito de modificar estes Termos de Uso a qualquer momento. As modificações entrarão em vigor imediatamente após a publicação no site.</p>
      </section>
      
      <section>
        <h2>7. Lei Aplicável</h2>
        <p>Estes Termos de Uso são regidos pelas leis do Brasil.</p>
      </section>
      
      <section>
        <h2>8. Contato</h2>
        <p>Se você tiver alguma dúvida sobre estes Termos de Uso, entre em contato conosco pelo e-mail: contato@exemplo.com.br</p>
      </section>
    </div>
  );
};

export default Terms;